(() => {
  const initialize = (root) => {
    const content = root.querySelector('[data-terms-of-service-content]');
    if (!content || content.dataset.termsOfServiceInitialized === 'true') return;

    const links = [...content.querySelectorAll('[data-terms-of-service-nav] a[href^="#terms-section-"]')];
    const sections = links.map((link) => content.querySelector(link.getAttribute('href')));
    if (!links.length || sections.some((section) => !section)) return;

    content.dataset.termsOfServiceInitialized = 'true';

    let clickTarget = null;
    let settleTimer;
    let finishClick;

    const setActive = (id) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', active);

        if (active) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const offset = () => {
      const value = getComputedStyle(root).getPropertyValue('--terms-scroll-offset');
      return parseFloat(value) * parseFloat(getComputedStyle(document.documentElement).fontSize) || 120;
    };

    const updateActive = () => {
      if (clickTarget) return;

      const boundary = offset() + 2;
      let current = sections[0];

      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= boundary) {
          current = section;
        }
      });

      setActive(current.id);
    };

    links.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const section = sections[index];
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (finishClick) {
          window.removeEventListener('scrollend', finishClick);
        }

        clearTimeout(settleTimer);
        clickTarget = section;

        finishClick = () => {
          clickTarget = null;
          window.removeEventListener('scrollend', finishClick);
          clearTimeout(settleTimer);
          updateActive();
        };

        section.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });

        history.pushState(null, '', `#${section.id}`);
        setActive(section.id);

        window.addEventListener('scrollend', finishClick, { once: true });
        settleTimer = setTimeout(finishClick, 1600);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(updateActive, {
        rootMargin: `-${Math.round(offset())}px 0px -55% 0px`,
        threshold: 0
      });

      sections.forEach((section) => observer.observe(section));
    }

    updateActive();
  };

  const start = () => document.querySelectorAll('.terms-of-service-page').forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();